module.exports = __webpack_public_path__ + "fonts/Mulish-Medium.4df899b7.ttf";